import { render, staticRenderFns } from "./cIndex.vue?vue&type=template&id=18a4ca90&scoped=true&"
import script from "./cIndex.vue?vue&type=script&lang=js&"
export * from "./cIndex.vue?vue&type=script&lang=js&"
import style0 from "./cIndex.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cIndex.vue?vue&type=style&index=1&id=18a4ca90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4ca90",
  null
  
)

export default component.exports